import { Skeleton } from '@components/ui/skeleton';

function Loading() {
  return (
    <div className="border-b p-4">
      <Skeleton className="h-8 w-80" />

      <div className="mb-2 mt-4 flex flex-row items-center gap-2">
        <Skeleton className="h-6 w-6" />
        <Skeleton className="h-6 w-[200px]" />
      </div>

      <div className="flex flex-col gap-y-1">
        <Skeleton className={`h-4 w-[370px]`} />
        <Skeleton className={`h-4 w-[170px]`} />
        <Skeleton className={`h-4 w-[270px]`} />
        <Skeleton className={`h-4 w-[310px]`} />
        <Skeleton className={`h-4 w-[250px]`} />
        <Skeleton className={`h-4 w-[180px]`} />
        <Skeleton className={`h-4 w-[350px]`} />
        <Skeleton className={`h-4 w-[220px]`} />
      </div>
    </div>
  );
}

export default Loading;
